import React, { Component } from "react";
import { connect } from "react-redux";

import { incrementPageCount } from "../../core/actions/pagination";
import { setRegisterTableWidths } from "../../core/actions/interface";

class _RegisterTableContainer extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {

        const { dispatch } = this.props;
        dispatch(setRegisterTableWidths(
            this.registerTable.offsetWidth + "px",
            this.registerTableScrollWrapper.offsetWidth + "px"
            )
        );

    }

    render() {

        const { dispatch, loadMoreConditional, children, tableHeaderIsFixed } = this.props;

        return (
            <div className="wrapper--registers">
                <div
                    className="u-flex table-scroll"
                    id="register-table-scroll-wrapper"
                    ref={ (ref) => this.registerTableScrollWrapper = ref }
                >
                    <div className={`u-flex-grow ${tableHeaderIsFixed ? "register-table-pr--fixed" : "u-pr--xsmall"}`}>
                        <table
                            className="table table--compact table-layout--fixed u-overflow-unset table--striped"
                            id="register-table"
                            ref={ (ref) => this.registerTable = ref }
                        >
                            { children }
                        </table>
                    </div>
                </div>
                { loadMoreConditional  &&
                    <div className="u-mt--small u-mb--small u-flex flex--justify-center">
                        <button className="btn" onClick={(e) => { e.preventDefault(); dispatch( incrementPageCount() ) }}>
                            Load more data
                        </button>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    tableHeaderIsFixed: state.mutableInterface.tableHeaderIsFixed,
});

export const RegisterTableContainer = connect(mapStateToProps)(_RegisterTableContainer);
